import type { IconProps } from '../types/IconProps.ts';
export const ScanQr: IconProps = {
    name: 'ScanQr',
    children: [
        `<path d="M21 8V5a2 2 0 0 0-2-2h-3M21 16v3a2 2 0 0 1-2 2h-3M3 16v3c0 1.1.9 2 2 2h3M3 8V5c0-1.1.9-2 2-2h3M17 7v1m-5 9h3a2 2 0 0 0 2-2v-3" />`,
        `<rect width="6" height="6" x="7" y="7" rx="1" />`,
        `<circle cx="7" cy="17" r=".5" />`,
    ]
};